import React from 'react';
import BattleRewards from './Components/BattleRewards';
import { InGameCategoryKey } from './types';
export const categories = [{
  key: InGameCategoryKey.BattleRewards,
  name: 'Heroes',
  renderCategory: () => /*#__PURE__*/React.createElement(BattleRewards, null)
}];